import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { pointInAABB, pointInCircle, pointInPolygon2, pointInRect, pointInSegment, pointInTriangle2, } from "@thi.ng/geom-isec";
import { isInArray } from "@thi.ng/vectors";
import { dispatch } from "../internal/dispatch";
export const pointInside = defmulti(dispatch);
pointInside.addAll({
    [Type.AABB]: ($, p) => pointInAABB(p, $.pos, $.size),
    [Type.CIRCLE]: ($, p) => pointInCircle(p, $.pos, $.r),
    [Type.LINE]: ($, p) => pointInSegment(p, $.points[0], $.points[1]),
    [Type.POINTS]: ({ points }, p) => isInArray(p, points),
    [Type.POLYGON]: ($, p) => pointInPolygon2(p, $.points) > 0,
    [Type.RECT]: ($, p) => pointInRect(p, $.pos, $.size),
    [Type.TRIANGLE]: (tri, p) => pointInTriangle2(p, ...tri.points),
});
pointInside.isa(Type.POINTS3, Type.POINTS);
pointInside.isa(Type.QUAD, Type.POLYGON);
pointInside.isa(Type.SPHERE, Type.CIRCLE);
